import { Box, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useStyles } from "./styles";

export const ItemsUser = ({ user, isCheck }: {
    user: {
        fullName: string;
        id: number | string;
    }
    isCheck: boolean
}) => {
    const styles = useStyles()
    const { control, } = useFormContext()
    return (
        <Controller
            control={control}
            name="selectedIds"
            render={({ field }) => {
                return (
                    <Grid item xs={6}>
                        <Box >
                            <FormControlLabel
                                sx={styles.check}
                                control={
                                    <Checkbox
                                        disableFocusRipple
                                        disableRipple
                                        onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            const value = user.id;
                                            if (isChecked) {
                                                field.onChange([...field.value, value.toString()]);
                                            } else {
                                                field.onChange(field.value.filter((id: number | string) => id != value));
                                            }
                                        }}
                                        value={user.id}
                                        checked={isCheck}
                                    />
                                }
                                label={user.fullName}
                            />
                        </Box>
                    </Grid>
                )
            }}
        />
    )
}